type LogData = unknown

enum LogLevel {
  INFO = 'INFO',
  WARN = 'WARN',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
}

interface LoggerOptions {
  loggerSource?: Console
}

const CONSOLE_METHOD: Record<LogLevel, 'log' | 'warn' | 'error' | 'info'> = {
  [LogLevel.INFO]: 'info',
  [LogLevel.WARN]: 'warn',
  [LogLevel.ERROR]: 'error',
  [LogLevel.SUCCESS]: 'log',
}

const LEVEL_STYLE: Record<LogLevel, string> = {
  [LogLevel.INFO]: 'color: #fff; background: #3b82f6; font-weight: bold; padding: 1px 6px; border-radius: 3px;',
  [LogLevel.WARN]: 'color: #000; background: #f59e0b; font-weight: bold; padding: 1px 6px; border-radius: 3px;',
  [LogLevel.ERROR]: 'color: #fff; background: #ef4444; font-weight: bold; padding: 1px 6px; border-radius: 3px;',
  [LogLevel.SUCCESS]: 'color: #fff; background: #22c55e; font-weight: bold; padding: 1px 6px; border-radius: 3px;',
}

export class Logger {
  constructor(
    private readonly source: string,
    private readonly options: LoggerOptions = {
      loggerSource: console,
    }
  ) {}

  info(message: string, data?: LogData) {
    this.print(LogLevel.INFO, message, data)
  }

  warn(message: string, data?: LogData) {
    this.print(LogLevel.WARN, message, data)
  }

  error(message: string, data?: LogData) {
    this.print(LogLevel.ERROR, message, data)
  }

  success(message: string, data?: LogData) {
    this.print(LogLevel.SUCCESS, message, data)
  }

  private print(level: LogLevel, message: string, data?: LogData) {
    const { loggerSource = console } = this.options ?? {}

    const prefix = `[${this.source}] [${level}]`
    const method = CONSOLE_METHOD[level]
    const style = LEVEL_STYLE[level]

    if (data === undefined) {
      loggerSource[method](`%c${prefix} ${message}`, style)
    } else {
      loggerSource[method](`%c${prefix} ${message}`, style, data)
    }
  }
}
